// src/pages/AttendanceTabs.jsx
// re-push trigger
import React, { useState } from 'react';
import BackButton from '../components/BackButton';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import AttendancePage from './AttendancePage';           // ثبت
import AttendanceManagePage from './AttendanceManagePage'; // مدیریت/بررسی

export default function AttendanceTabs() {
  const [tab, setTab] = useState(0);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ p: 2 }}>
      <BackButton toFallback="/dashboard" />
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab icon={<SaveIcon />} iconPosition="start" label="ثبت حضور و غیاب" />
          <Tab icon={<EditIcon />} iconPosition="start" label="تغییرات و بررسی" />
        </Tabs>
      </Paper>

      {tab === 0 && <AttendancePage />}
      {tab === 1 && <AttendanceManagePage />}
    </Box>
  );
}